var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarIn = function SvgCalendarIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#DEDEDE",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.343 0c.473 0 .857.384.857.857v.972h5.6V.857a.857.857 0 1 1 1.714 0v.972h.972A4.514 4.514 0 0 1 20 6.343v9.143A4.514 4.514 0 0 1 15.486 20H4.514A4.514 4.514 0 0 1 0 15.486C0 15.217.217 15 .486 15h.743c.268 0 .485.217.485.486a2.8 2.8 0 0 0 2.8 2.8h10.972a2.8 2.8 0 0 0 2.8-2.8V9.029H1.714V9.5a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5V6.343a4.514 4.514 0 0 1 4.514-4.514h.972V.857c0-.473.384-.857.857-.857m11.943 6.343v.971H1.714v-.971a2.8 2.8 0 0 1 2.8-2.8h.972v.971a.857.857 0 0 0 1.714 0v-.971h5.6v.971a.857.857 0 1 0 1.714 0v-.971h.972a2.8 2.8 0 0 1 2.8 2.8",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.75A.75.75 0 0 1 .75 12h5.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53 10.53a.75.75 0 0 1 1.061 0l1.768 1.768a.75.75 0 0 1-1.06 1.06L4.53 11.592a.75.75 0 0 1 0-1.06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.359 12.298a.75.75 0 0 1 0 1.06L5.59 15.127a.75.75 0 0 1-1.06-1.06l1.767-1.768a.75.75 0 0 1 1.06 0"
  })));
};
export default SvgCalendarIn;